import * as React from "react"
import Svg, { G, Path, Defs, LinearGradient, Stop } from "react-native-svg"

function PlayStoreSvg(props) {
  return (
    <Svg
      width={187}
      height={56}
      viewBox="0 0 187 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G opacity={0.8}>
        <Path
          d="M179.436 55.212H7.178c-3.79 0-6.89-3.106-6.89-6.902V6.901C.288 3.106 3.388 0 7.178 0h172.258c3.789 0 6.89 3.106 6.89 6.901v41.41c0 3.795-3.1 6.9-6.89 6.9z"
          fill="#000"
        />
        <Path
          d="M65.635 14.14c0 1.157-.342 2.078-1.026 2.764-.778.817-1.792 1.226-3.038 1.226-1.193 0-2.208-.414-3.042-1.243-.836-.83-1.254-1.857-1.254-3.083 0-1.226.418-2.254 1.254-3.083.834-.829 1.849-1.243 3.042-1.243.592 0 1.16.116 1.697.347.539.232.97.54 1.293.925l-.726.729c-.548-.655-1.302-.983-2.264-.983-.87 0-1.623.307-2.258.92s-.953 1.41-.953 2.388c0 .98.318 1.775.953 2.389.635.613 1.388.92 2.258.92.923 0 1.693-.309 2.31-.926.4-.401.63-.96.693-1.677H61.57v-.995h4.007c.038.216.057.424.057.625"
          fill="#fff"
        />
        <Path
          d="M65.632 14.137h-.138c0 1.13-.33 2.008-.986 2.667l-.001.001-.001.001c-.753.789-1.721 1.181-2.938 1.183-1.162-.002-2.134-.398-2.946-1.203-.81-.806-1.21-1.79-1.212-2.985.002-1.195.402-2.178 1.212-2.984.812-.805 1.784-1.202 2.946-1.204.574 0 1.121.112 1.643.336.522.225.934.52 1.242.887l.105-.089-.097-.097-.727.729.097.097.106-.089c-.572-.687-1.377-1.034-2.37-1.032a3.28 3.28 0 00-2.353.959c-.663.638-.996 1.479-.995 2.487-.001 1.01.332 1.85.995 2.488.657.636 1.451.96 2.354.958.954.002 1.767-.322 2.407-.965.427-.43.67-1.024.733-1.763l.013-.15h-3.015v-.719h3.868v-.138l-.135.025c.038.209.055.408.055.6h.276c0-.21-.02-.425-.06-.65l-.02-.113h-4.26v1.271h3.14v-.138l-.137-.012c-.06.695-.281 1.218-.653 1.592-.592.59-1.32.883-2.212.884-.838 0-1.55-.29-2.162-.88-.608-.589-.91-1.34-.911-2.29.001-.95.303-1.7.91-2.289.614-.59 1.325-.88 2.163-.88.932.002 1.635.31 2.158.933l.097.115.833-.835.089-.09-.081-.096c-.339-.404-.79-.725-1.345-.963a4.395 4.395 0 00-1.751-.36c-1.225 0-2.282.431-3.14 1.285-.86.852-1.295 1.922-1.293 3.18-.002 1.258.432 2.33 1.294 3.182.856.852 1.914 1.283 3.139 1.282 1.276.001 2.334-.423 3.137-1.268l-.1-.095.098.097c.714-.714 1.068-1.68 1.067-2.862h-.138zm6.352-3.46H68.22v2.627h3.395v.995H68.22v2.626h3.765v1.017h-4.827V9.66h4.827v1.018z"
          fill="#fff"
        />
        <Path
          d="M71.986 10.682v-.138h-3.904v2.902h3.396v.718h-3.396v2.903h3.766v.741h-4.552V9.802h4.552v.88h.138v-.138.138h.137V9.526h-5.102v8.558h5.102v-1.293h-3.765v-2.35h3.396V13.17h-3.396v-2.35h3.765v-.138h-.137zm4.48 7.264h-1.063v-7.264h-2.31V9.664h5.682v1.018h-2.31v7.264"
          fill="#fff"
        />
        <Path
          d="M76.465 17.946v-.138h-.925v-7.264h-2.31v-.742h5.407v.742h-2.31v7.402h.138v-.138.138h.138V10.82h2.31V9.526h-5.958v1.294h2.31v7.264h1.338v-.138h-.138zm6.42 0V9.664h1.063v8.282h-1.062"
          fill="#fff"
        />
        <Path
          d="M82.885 17.946h.138V9.802h.787v8.006h-.925v.138h.138-.138v.138h1.2V9.526h-1.337v8.558h.137v-.138zm5.775 0h-1.063v-7.264h-2.31V9.664h5.683v1.018h-2.31v7.264"
          fill="#fff"
        />
        <Path
          d="M88.66 17.945v-.138h-.925v-7.264h-2.309V9.8h5.406v.742h-2.31v7.402h.139v-.138.138h.137v-7.126h2.31V9.525H85.15v1.294h2.31v7.264h1.338v-.138h-.137zm7.788-1.764c.612.621 1.36.931 2.246.931.886 0 1.635-.31 2.246-.93.612-.621.919-1.414.919-2.378 0-.963-.307-1.757-.919-2.377-.611-.62-1.36-.93-2.246-.93-.885 0-1.634.31-2.246.93-.611.62-.918 1.414-.918 2.377 0 .964.307 1.757.918 2.377zm5.278.694c-.813.837-1.824 1.255-3.032 1.255-1.209 0-2.22-.418-3.03-1.255-.814-.837-1.219-1.86-1.219-3.07 0-1.211.405-2.235 1.219-3.071.81-.838 1.821-1.256 3.03-1.256 1.202 0 2.21.42 3.026 1.261.816.84 1.224 1.862 1.224 3.065 0 1.21-.407 2.234-1.218 3.07z"
          fill="#fff"
        />
        <Path
          d="M96.447 16.179l-.098.097c.635.645 1.426.973 2.344.971.917.002 1.71-.326 2.344-.971.639-.646.96-1.482.959-2.475.001-.992-.32-1.828-.959-2.474-.634-.645-1.427-.973-2.344-.972-.918-.001-1.71.327-2.344.972-.638.646-.96 1.482-.958 2.474-.002.993.32 1.829.958 2.475l.098-.097.098-.097c-.585-.596-.877-1.346-.878-2.28 0-.935.293-1.685.878-2.28.59-.597 1.294-.889 2.148-.89.853.001 1.56.293 2.148.89.586.595.878 1.345.879 2.28-.001.934-.293 1.684-.879 2.28-.588.595-1.295.887-2.148.89-.854-.003-1.558-.295-2.148-.89l-.098.097zm5.278.693l-.099-.096c-.79.81-1.756 1.212-2.933 1.213-1.177-.002-2.143-.402-2.932-1.213l-.004-.004.004.004c-.789-.814-1.178-1.795-1.179-2.975.001-1.18.39-2.16 1.179-2.974.789-.811 1.755-1.212 2.932-1.214 1.17.002 2.133.404 2.928 1.22.791.817 1.183 1.797 1.184 2.968-.001 1.18-.392 2.161-1.179 2.975l.099.096.099.096c.835-.86 1.258-1.925 1.257-3.167.001-1.234-.423-2.298-1.263-3.16-.839-.867-1.891-1.306-3.125-1.304-1.24-.002-2.295.435-3.13 1.298-.837.86-1.258 1.925-1.257 3.166 0 1.242.42 2.307 1.257 3.167l.004.004-.004-.004c.835.863 1.89 1.298 3.13 1.297 1.24.001 2.295-.434 3.131-1.297l-.099-.096zm2.709 1.07V9.66h1.293l4.019 6.443h.045l-.045-1.596V9.66h1.063v8.282H109.7l-4.204-6.755h-.046l.046 1.597v5.158h-1.062"
          fill="#fff"
        />
        <Path
          d="M104.437 17.946h.138V9.802h1.079l4.018 6.443h.264l-.05-1.736V9.802h.788v8.006h-.895l-4.204-6.755h-.264l.05 1.737v5.018h-.924v.138h.138-.138v.138h1.199v-5.298l-.045-1.598-.138.003v.138h.046v-.138l-.117.074 4.244 6.82h1.324V9.525h-1.339v4.987l.045 1.598.138-.004v-.138h-.045v.138l.116-.073-4.059-6.508h-1.507v8.558h.138v-.138zm43.217 23.465h2.571V24.156h-2.571V41.41zm23.161-11.04l-2.948 7.482h-.088l-3.059-7.482h-2.77l4.587 10.457-2.615 5.816h2.683l7.069-16.272h-2.859zm-14.583 9.08c-.843 0-2.017-.422-2.017-1.465 0-1.332 1.463-1.843 2.726-1.843 1.131 0 1.662.245 2.349.578-.2 1.598-1.574 2.73-3.058 2.73zm.31-9.457c-1.861 0-3.789.822-4.587 2.642l2.282.954c.488-.954 1.396-1.265 2.35-1.265 1.329 0 2.681.8 2.703 2.22v.178c-.466-.267-1.462-.666-2.681-.666-2.46 0-4.966 1.353-4.966 3.884 0 2.31 2.018 3.797 4.278 3.797 1.729 0 2.682-.777 3.281-1.687h.088v1.331h2.482v-6.615c0-3.063-2.282-4.773-5.23-4.773zm-15.891 2.478h-3.658v-5.915h3.658c1.922 0 3.013 1.595 3.013 2.958 0 1.337-1.091 2.957-3.013 2.957zm-.067-8.316h-6.161V41.41h2.57v-6.537h3.591c2.85 0 5.652-2.067 5.652-5.36 0-3.291-2.802-5.358-5.652-5.358zm-33.598 15.298c-1.777 0-3.264-1.49-3.264-3.535 0-2.068 1.487-3.58 3.264-3.58 1.754 0 3.13 1.512 3.13 3.58 0 2.046-1.376 3.535-3.13 3.535zm2.953-8.116h-.089c-.577-.69-1.688-1.312-3.086-1.312-2.931 0-5.617 2.58-5.617 5.893 0 3.29 2.686 5.848 5.617 5.848 1.398 0 2.509-.623 3.086-1.334h.089v.845c0 2.246-1.199 3.447-3.131 3.447-1.576 0-2.553-1.135-2.953-2.09l-2.242.933c.644 1.557 2.354 3.47 5.195 3.47 3.02 0 5.573-1.78 5.573-6.116v-10.54h-2.442v.956zm4.218 10.073h2.575V24.155h-2.575v17.256zm6.372-5.693c-.067-2.268 1.753-3.424 3.063-3.424 1.022 0 1.887.511 2.176 1.246l-5.239 2.178zm7.992-1.956c-.488-1.313-1.976-3.736-5.018-3.736-3.019 0-5.528 2.38-5.528 5.87 0 3.292 2.487 5.87 5.817 5.87 2.687 0 4.241-1.645 4.885-2.6l-1.999-1.335c-.665.978-1.576 1.623-2.886 1.623s-2.242-.6-2.842-1.778l7.837-3.247-.266-.667zm-62.437-1.935v2.49h5.95c-.178 1.401-.645 2.424-1.355 3.136-.866.867-2.22 1.823-4.596 1.823-3.663 0-6.527-2.957-6.527-6.626 0-3.67 2.864-6.627 6.528-6.627 1.975 0 3.418.779 4.484 1.78l1.754-1.757c-1.487-1.424-3.464-2.513-6.239-2.513-5.017 0-9.235 4.091-9.235 9.117 0 5.026 4.218 9.117 9.236 9.117 2.708 0 4.75-.89 6.349-2.557 1.643-1.646 2.153-3.959 2.153-5.826 0-.579-.044-1.112-.133-1.557h-8.37zm15.267 7.627c-1.777 0-3.309-1.467-3.309-3.558 0-2.112 1.532-3.558 3.309-3.558 1.776 0 3.308 1.446 3.308 3.558 0 2.09-1.532 3.558-3.308 3.558zm0-9.428c-3.242 0-5.884 2.468-5.884 5.87 0 3.38 2.642 5.87 5.884 5.87 3.24 0 5.883-2.49 5.883-5.87 0-3.402-2.642-5.87-5.883-5.87zm12.834 9.428c-1.776 0-3.308-1.467-3.308-3.558 0-2.112 1.532-3.558 3.308-3.558 1.776 0 3.308 1.446 3.308 3.558 0 2.09-1.532 3.558-3.308 3.558zm0-9.428c-3.242 0-5.883 2.468-5.883 5.87 0 3.38 2.641 5.87 5.883 5.87 3.241 0 5.883-2.49 5.883-5.87 0-3.402-2.642-5.87-5.883-5.87z"
          fill="#fff"
        />
        <Path
          d="M14.772 10.508c-.463.418-.739 1.115-.739 2.04v-.209 30.534-.201c0 .854.237 1.514.638 1.94l.103.097c.324.294.74.45 1.217.45.466 0 .99-.15 1.544-.464l20.003-11.383 6.87-3.91c.873-.497 1.363-1.138 1.445-1.79v-.003c-.082-.654-.572-1.294-1.444-1.79l-6.872-3.91-20.002-11.384c-.554-.315-1.08-.465-1.546-.465-.477 0-.893.156-1.217.448z"
          fill="#00C1FF"
        />
        <Path
          d="M14.774 44.704l-.103-.098c-.4-.425-.638-1.085-.638-1.94v.202-30.526.201c0-.925.277-1.622.739-2.04l17.074 17.101-17.072 17.1z"
          fill="url(#paint0_linear_95_1918)"
        />
        <Path
          d="M37.533 33.309l-5.692-5.703 5.692-5.701 6.871 3.91c.873.497 1.363 1.137 1.445 1.79v.003c-.082.653-.572 1.293-1.445 1.79l-6.87 3.91"
          fill="url(#paint1_linear_95_1918)"
        />
        <Path
          d="M15.988 45.154a1.77 1.77 0 01-1.217-.448l17.072-17.1 5.692 5.701-20.003 11.384c-.553.314-1.078.463-1.544.463z"
          fill="url(#paint2_linear_95_1918)"
        />
        <Path
          d="M31.843 27.607l-17.074-17.1c.325-.293.74-.449 1.216-.449.468 0 .993.15 1.547.465l20.002 11.383-5.691 5.701"
          fill="url(#paint3_linear_95_1918)"
        />
        <Path
          d="M15.99 45.356c-.476 0-.893-.156-1.218-.449a.037.037 0 00-.005-.003l-.088-.087-.01-.01.103-.102c.325.294.741.45 1.218.449.466 0 .99-.149 1.544-.463l20.003-11.384.128.129-.13.074-20.001 11.383c-.505.286-.984.435-1.418.46a2.523 2.523 0 01-.126.003"
          fill="url(#paint4_linear_95_1918)"
        />
        <Path
          d="M14.671 44.807c-.4-.425-.638-1.085-.638-1.94v-.2c0 .854.237 1.514.638 1.938l.103.099-.103.103z"
          fill="url(#paint5_linear_95_1918)"
        />
        <Path
          d="M37.664 33.439l-.128-.129 6.87-3.91c.873-.497 1.363-1.137 1.445-1.79 0 .24-.053.48-.16.712-.213.47-.642.913-1.285 1.28l-6.742 3.837"
          fill="url(#paint6_linear_95_1918)"
        />
        <Path
          d="M45.851 27.607c-.081-.654-.571-1.294-1.444-1.79l-6.871-3.91.128-.129 6.743 3.838c.962.547 1.444 1.27 1.444 1.991z"
          fill="url(#paint7_linear_95_1918)"
        />
        <Path
          d="M14.033 12.548v-.21c0-.077.003-.151.006-.223v-.004-.011c.042-.736.27-1.31.632-1.693l.101.101c-.463.418-.739 1.115-.739 2.04z"
          fill="url(#paint8_linear_95_1918)"
        />
        <Path
          d="M37.536 21.908L17.534 10.524c-.555-.315-1.08-.464-1.547-.464-.476 0-.892.155-1.216.448l-.101-.101c.031-.034.064-.066.098-.097l.004-.003c.322-.29.733-.446 1.205-.449h.01c.467 0 .992.15 1.547.464l20.13 11.457-.128.129z"
          fill="url(#paint9_linear_95_1918)"
        />
      </G>
      <Defs>
        <LinearGradient
          id="paint0_linear_95_1918"
          x1={24.9447}
          y1={12.0191}
          x2={10.2308}
          y2={26.7566}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#00A0FF" />
          <Stop offset={0.00657} stopColor="#00A1FF" />
          <Stop offset={0.2601} stopColor="#00BEFF" />
          <Stop offset={0.5122} stopColor="#00D2FF" />
          <Stop offset={0.7604} stopColor="#00DFFF" />
          <Stop offset={1} stopColor="#00E3FF" />
        </LinearGradient>
        <LinearGradient
          id="paint1_linear_95_1918"
          x1={46.9119}
          y1={27.5078}
          x2={13.5669}
          y2={27.5078}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFE000" />
          <Stop offset={0.4087} stopColor="#FFBD00" />
          <Stop offset={0.7754} stopColor="orange" />
          <Stop offset={1} stopColor="#FF9C00" />
        </LinearGradient>
        <LinearGradient
          id="paint2_linear_95_1918"
          x1={34.5131}
          y1={33.0267}
          x2={9.57928}
          y2={57.8182}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FF3A44" />
          <Stop offset={1} stopColor="#C31162" />
        </LinearGradient>
        <LinearGradient
          id="paint3_linear_95_1918"
          x1={10.3685}
          y1={7.97101}
          x2={21.4809}
          y2={19.037}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#32A071" />
          <Stop offset={0.0685} stopColor="#2DA771" />
          <Stop offset={0.4762} stopColor="#15CF74" />
          <Stop offset={0.8009} stopColor="#06E775" />
          <Stop offset={1} stopColor="#00F076" />
        </LinearGradient>
        <LinearGradient
          id="paint4_linear_95_1918"
          x1={34.5022}
          y1={36.9819}
          x2={14.534}
          y2={56.9824}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#CC2E36" />
          <Stop offset={1} stopColor="#9C0E4E" />
        </LinearGradient>
        <LinearGradient
          id="paint5_linear_95_1918"
          x1={16.3079}
          y1={12.0186}
          x2={3.34522}
          y2={25.0024}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#008DE0" />
          <Stop offset={0.00657} stopColor="#008DE0" />
          <Stop offset={0.2601} stopColor="#00A7E0" />
          <Stop offset={0.5122} stopColor="#00B8E0" />
          <Stop offset={0.7604} stopColor="#00C4E0" />
          <Stop offset={1} stopColor="#00C7E0" />
        </LinearGradient>
        <LinearGradient
          id="paint6_linear_95_1918"
          x1={46.9141}
          y1={27.6091}
          x2={13.5691}
          y2={27.6091}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#E0C500" />
          <Stop offset={0.4087} stopColor="#E0A600" />
          <Stop offset={0.7754} stopColor="#E09100" />
          <Stop offset={1} stopColor="#E08900" />
        </LinearGradient>
        <LinearGradient
          id="paint7_linear_95_1918"
          x1={46.9146}
          y1={27.6088}
          x2={13.5697}
          y2={27.6088}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFE840" />
          <Stop offset={0.4087} stopColor="#FFCE40" />
          <Stop offset={0.7754} stopColor="#FFBC40" />
          <Stop offset={1} stopColor="#FFB540" />
        </LinearGradient>
        <LinearGradient
          id="paint8_linear_95_1918"
          x1={16.2939}
          y1={12.0475}
          x2={3.80848}
          y2={24.0113}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#40B8FF" />
          <Stop offset={0.00657} stopColor="#40B9FF" />
          <Stop offset={0.2601} stopColor="#40CEFF" />
          <Stop offset={0.5122} stopColor="#40DDFF" />
          <Stop offset={0.7604} stopColor="#40E7FF" />
          <Stop offset={1} stopColor="#40EAFF" />
        </LinearGradient>
        <LinearGradient
          id="paint9_linear_95_1918"
          x1={10.3453}
          y1={11.5891}
          x2={19.262}
          y2={20.5203}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#65B895" />
          <Stop offset={0.0685} stopColor="#62BD95" />
          <Stop offset={0.4762} stopColor="#50DB97" />
          <Stop offset={0.8009} stopColor="#44ED98" />
          <Stop offset={1} stopColor="#40F498" />
        </LinearGradient>
      </Defs>
    </Svg>
  )
}

export default PlayStoreSvg
